import React from 'react';
import { css } from 'emotion';
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import { TimePicker as DesignTimePicker } from '@whalecloud/fdx';
import FormItem from "@whalecloud/page-builder-core/components/Render/components/FormItem";

const left = css({ textAlign: 'left' });
const TimePicker = props => {
  const { element } = props;
  const { formItemSettings, formSettings, settings, className = '' } = element.data;
  const { width, horizontalAlign = 'left' } = settings;

  return (
    <ElementRoot className={'webiny-pb-base-page-element-style'} element={element}>
      {({ getAllClasses, elementStyle }) => (
        <div style={{ textAlign: horizontalAlign }}>
          <FormItem
            id={element.id}
            style={elementStyle}
            className={getAllClasses('webiny-pb-base-page-element-style', 'webiny-pb-page-element-time-picker', left)}
            {...formSettings}
          >
            <DesignTimePicker style={{ width: width.value }} {...formItemSettings} className={className} />
          </FormItem>
        </div>
      )}
    </ElementRoot>
  );
};

export default TimePicker;
